var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.73154 15.718V7.92608C2.73154 6.54837 3.27883 5.2271 4.25302 4.25292C5.2272 3.27874 6.54847 2.73145 7.92617 2.73145C9.30388 2.73145 10.6252 3.27874 11.5993 4.25292C12.5735 5.2271 13.1208 6.54837 13.1208 7.92608V15.718M2.73154 15.718H13.1208M2.73154 15.718H1M13.1208 15.718H14.8523M7.0604 18.3153H8.79195",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.9262 2.73154C8.40435 2.73154 8.79197 2.34392 8.79197 1.86577C8.79197 1.38762 8.40435 1 7.9262 1C7.44804 1 7.06042 1.38762 7.06042 1.86577C7.06042 2.34392 7.44804 2.73154 7.9262 2.73154Z",
    stroke: "black",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.3af4b34fc841c6312766fbe266da16f6.svg";
export { ForwardRef as ReactComponent };